<template>
  <div>
    <div class="evolution">
      <div class="evolution_nav">
        <div class="search_top">
          <div class="editorial_txt">
            <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px;"></div>
            <div class="editorial_txt2">
              首页 <span class="span1">></span> <span class="span2">搜索结果页</span>
            </div>
          </div>
          <div class="search_type">
            <ul>
            	<li v-for="(item,index) in type" :key="index" @click="qie(item.id)"><span :class="item.zt?'addcu':''">{{item.name}}</span><span v-if="index!=type.length-1" style="margin-left: 28px;">|</span></li>
            </ul>
          </div>
          <div class="search_txt">
            为您检索到： <span class="search_txt2">{{searchtxt}}</span><span style="color: #D93125;margin-right: 10px;">{{totalcount}}</span>条结果
          </div>
        </div>
        <div class="evolution_middle" :class="id==2 || id==1?'top':''">
          <div style="width: 100%;margin: 0 auto;">
            <div v-if="id!=2 && id!=1 && id!=3" style="width: 95%;">
              <div class="express_nav2r">
                <div class="express_list2" v-for="(item,index) in deeds" :key="index" @click="jump(item.dataType,10,item.id,item.channelID?item.channelID:item.channelId,item.year,item.issue)">
                  <div class="express_dian" :class="item.zt?'add2':''" @mouseover="addtop(1,index)" @mouseout="addtop(2,index)"></div>
                  <div class="express_wen" @mouseover="addtop(1,index)" @mouseout="addtop(2,index)" style="overflow: hidden;width: 96%;">
                    <div class="wen1" :class="item.zt?'add1':''" style="float: left;">
                      <span class="span3" :class="item.zt?'add1':''" v-if="searchtxt"><span v-html="brightenKeyword(item.title, searchtxt)"></span></span>
                      <span class="span3" :class="item.zt?'add1':''" v-if="!searchtxt">{{item.title}}</span>
                      <span style="max-width: 30%; float: right;text-align: right;">{{item.addDate}}</span></div>
                  </div>
                </div>
              </div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="curr"
                layout="prev, pager, next, jumper"
                :total="totalcount">
              </el-pagination>
            </div>
            <div v-if="id==3" style="width: 95%;">
              <div class="browse_list">
                <div class="author_nav2r">
                  <div class="author_list2" v-for="(item,index) in deeds" :key="index"  @mouseover="addtop(1,index)" @mouseout="addtop(2,index)" @click="jumpxq(item.id,item.year,item.issue)">
                    <div class="author_wen">
                      <div class="wen11" v-if="item.channelName!='' && item.channelName!=null"><div class="author_dian"></div>{{item.channelName}}</div>
                      <div class="wen1" :class="item.zt?'add1':''" v-if="searchtxt"><span v-html="brightenKeyword(item.title, searchtxt)"></span></div>
                      <div class="wen1" :class="item.zt?'add1':''" v-if="!searchtxt">{{item.title}}</div>
                      <div class="wen2">{{item.authors}}</div>
                    </div>
                    <div class="zhai">
                      <div class="wen3">
                        {{item.yearVolumeIssue}}&nbsp;&nbsp;&nbsp;&nbsp;
                        下载次数：<span>{{item.downloads}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                        引用频次：<span>{{item.htmlHits}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                        阅读次数：<span>{{item.hits}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                        网刊下载次数：<span>{{item.downloads}}</span>
                      </div>
                      <div style="width: 16%;float: right;">
                        <div class="zhai_right" @click.stop="down(item.id)"><span class="iconfont iconxiazai" style="margin-right: 8px;"></span>下载</div>
                        <div class="zhai_left"><span class="iconfont iconzhaiyaowxy123" style="margin-right: 8px;"></span>摘要</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="curr"
                layout="prev, pager, next, jumper"
                :total="totalcount">
              </el-pagination>
            </div>
            <middlenav :middle="middle" :deeds="deeds" :cename="cename" :show2="show2" :searchtxt="searchtxt" :totalcount="totalcount" @currentPage3="currentPage3" @shua="shua" v-if="totalcount>0 && id==1 || id==2"></middlenav>
          </div>
        </div>
        <div class="evolution_right">
          <advertisement :num="num" :list2="list2"></advertisement>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//配置左侧悬浮简介导航
import leftbrief from "../public/evolution/leftbrief.vue"
//配置中间内容栏
import middlenav from "../public/evolution/evolution_nav.vue"
//配置右侧广告栏
import advertisement from "../public/evolution/advertisement.vue"

export default {
  components: {
    leftbrief,
    advertisement,
    middlenav
  },
  data () {
    return {
      id: 0,
      curr: 1,
      totalcount: 0,
      searchtxt: '',//搜索框内容
      show2: true,
      cename: '搜索',
      titlename: '首页',
      title: '历届会议',
      txt: '历届会议',
      num:{
        wai: false,
        zixun: true,
        xia: true,
        look: false,
		video2: true,
      },//控制广告栏的显示隐藏
      middle:{
        brief: false,//杂志简介
        inscription: false,//领导及专家题词
        Deeds: true,//发展大事记
        Awards: false,//获奖情况
        Included: false,//检索机构收录情况
        paper: false,//论文统计与分析
        blessing: false,//祝福集锦
        meeting: false,//编委会会议
      },//中间内容区域展示模块显示隐藏
      type: [
        {
          id: 0,
          name: '全部'
        },
        {
          id: 1,
          name: '资讯'
        },
        {
          id: 2,
          name: '视频'
        },
        {
          id: 3,
          name: '文献'
        }
      ],//类型
      list: [
        {
           id: 8,
           txt: '学术会议'
        },
        {
           id: 9,
           txt: '编辑委员会会议'
        },
      ],//简介导航
      list2: [
        {
          id: 1,
          txt: '多西他赛对进展期胃癌术后化疗疗效影响向...'
        },
        {
          id: 2,
          txt: '中国腹腔镜减重代谢外科20年研究文献分析...'
        }
      ],//外科天地
      deeds: [],//发展大事记
    }
  },
  watch:{
    '$route'(to,from){
      this.searchtxt = this.$route.query.searchtxt;
      this.GetSiteSearch(this.id);
    }
  },
  methods:{
    shua(e){
      if(this.id==0){
        this.GetSiteSearch(0);
      }else if(this.id==1){
        this.GetSiteSearch(1);
      }else if(this.id==2){
        this.GetSiteSearch(2);
      }else if(this.id==3){
        this.GetSiteSearch(3);
      }
    },
    //关键词变色
    brightenKeyword(val, keyword) {
      // 方法2：用正则表达式
      const Reg = new RegExp(keyword, "i");
      if (val) {
        const res = val.replace(
          Reg,
          `<span style="color: var(--xt);">${keyword}</span>`
        );
        return res;
      }
    },
    down(contentId){
      var that = this;
      that.$httphelper.GetContentFilePath({
        "journalId": 201607080003,
        "contentId": contentId,
        "downType": 1
      }).then(res => {
        if(res.code==200){
          window.open(res.data);
          that.$loading.hideLoading();
        }else{
          that.$alert('没有附件', '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    jump(type,num,contentId,channelId,year,issue){
      if(type==1){
        this.$router.push({path:'/expert_details',query:{num: num,contentId: contentId,channelId:channelId}});
      }else if(type==2){
        this.$router.push({path:'/surgery_details',query:{contentId:contentId}});
      }else if(type==3){
        this.$router.push({path:'/browse_details',query:{year:year,issue:issue,issuecid:contentId}});
      }
    },
    jumpxq(contentId,year,issue){
      this.$router.push({path:'/browse_details',query:{year:year,issue:issue,issuecid:contentId}});
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.curr = val;
      if(this.id==0){
        this.GetSiteSearch(0);
      }else if(this.id==1){
        this.GetSiteSearch(1);
      }else if(this.id==2){
        this.GetSiteSearch(2);
      }else if(this.id==3){
        this.GetSiteSearch(3);
      }
      console.log(`当前页: ${val}`);
    },
    //鼠标悬停
    addtop(num,id){
      if(num==1){
        for(var i=0;i<this.deeds.length;i++){
          if(id==i){
            this.deeds[i].zt = true;
            this.deeds.push('1');
            this.deeds.pop('1');
          }
        }
      }else{
        for(var i=0;i<this.deeds.length;i++){
          this.deeds[i].zt = false;
          this.deeds.push('1');
          this.deeds.pop('1');
        }
      }
    },
    currentPage3(e){
      console.log(e,this.id,'这个页面实际')
      this.curr = e;
      if(this.id==0){
        this.GetSiteSearch(0);
      }else if(this.id==1){
        this.GetSiteSearch(1);
      }else if(this.id==2){
        this.GetSiteSearch(2);
      }else if(this.id==3){
        this.GetSiteSearch(3);
      }
    },
    //左侧导航栏点击切换内容事件
    name(e){
      console.log(e,'e!!!!!!!!!!!')
      this.cename = e;
    },
    qie(id){
      this.$loading.showLoading();
      this.curr = 1;
      this.id = id;
      for(var i=0;i<this.type.length;i++){
        if(id==i){
          this.type[i].zt = true;
          this.type.push('1');
          this.type.pop('1');
        }else{
          this.type[i].zt = false;
          this.type.push('1');
          this.type.pop('1');
        }
      }
      this.GetSiteSearch(id);
    },
    //左侧导航栏点击切换内容事件
    dian(e){
      this.middle.brief = e.brief;
      this.middle.inscription = e.inscription;
      this.middle.Deeds = e.Deeds;
      this.middle.Awards = e.Awards;
      this.middle.Included = e.Included;
      this.middle.paper = e.paper;
      this.middle.blessing = e.blessing;
      this.middle.meeting = e.meeting;
    },
    //网站搜索
    GetSiteSearch(searchType){
      var that = this;
      that.$httphelper.GetSiteSearch({
        "keywords": that.searchtxt,
        "searchType": searchType,
        "journalId": that.$_JournalId,
        "curr": that.curr,
        "limit": 10,
      }).then(res => {
        if(res.code==200){
          if(searchType==0){
            that.deeds = res.data.siteSearchAllList || '';
            that.totalcount = res.totalcount;
          }else if(searchType==1){
            that.deeds = res.data.siteSearchNewsList || '';
            that.totalcount = res.totalcount;
          }else if(searchType==2){
            that.deeds = res.data.siteSearchVideoList || '';
            that.totalcount = res.totalcount;
          }else if(searchType==3){
            that.deeds = res.data.siteSearchIssueList || '';
            that.totalcount = res.totalcount;
          }
          console.log(that.totalcount,'totalcounttotalcounttotalcounttotalcount')
          that.$loading.hideLoading();
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    //页面初始化
    index(){
      this.searchtxt = this.$route.query.searchtxt;
      for(var i=0;i<this.type.length;i++){
        if(i==0){
          this.type[i].zt = true;
          this.type.push('1');
          this.type.pop('1');
        }else{
          this.type[i].zt = false;
          this.type.push('1');
          this.type.pop('1');
        }
      }
      this.GetSiteSearch(this.id);
    },
    //外科天地鼠标悬停
    // addtop2(num,id){
    //   if(num==1){
    //     for(var i=0;i<this.list2.length;i++){
    //       if(id==i){
    //         this.list2[i].zt = true;
    //         this.list2.push('1');
    //         this.list2.pop('1');
    //       }
    //     }
    //   }else{
    //     for(var i=0;i<this.list2.length;i++){
    //       this.list2[i].zt = false;
    //       this.list2.push('1');
    //       this.list2.pop('1');
    //     }
    //   }
    // },
  },
  created(){
    this.index();
  }
}
</script>

<style lang="scss" scoped>
*{
    margin: 0;
    padding: 0;
}
.evolution{
  width: 100%;
  min-width: 1366px;
  background-color: #FFFFFF;
  margin-top: 24px;
  margin-bottom: 78px;
  .evolution_nav{
    width: 85%;
    margin: 0 auto;
    overflow: hidden;
    .search_top{
      width: 100%;
      overflow: hidden;
      .editorial_txt{
        width: 100%;
        margin-top: 24px;
        margin-bottom: 26px;
        overflow: hidden;
        .evolution_tu{
          width: 19px;
          height: 17px;
          float: left;
        }
        .editorial_txt2{
          float: left;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #010101;
          .span1 {
            margin: 0 5px;
          }
          .span2 {
            color: var(--xt);
          }
        }
      }
      .search_type{
        width: 100%;
        position: relative;
        ul{
          list-style: none;
          overflow: hidden;
          border-bottom: 1px solid #E2E2E2;
          padding-bottom: 10px;
          li{
            width: 100px;
            float: left;
            text-align: center;
            line-height: 38px;
            font-size: 16px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #000000;
            cursor: pointer;
          }
        }
      }
      .search_txt{
        width: 100%;
        margin-top: 26px;
        line-height: 26px;
        .search_txt2{
          width: auto;
          display: inline;
          line-height: 26px;
          text-align: center;
          background-color: var(--xt);
          font-size: 16px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #FFFFFF;
          padding: 5px 10px;
          margin-right: 10px;
        }
      }
    }
    .evolution_middle{
      width: 75%;
      float: left;
      .express_nav2r {
        width: 100%;
        overflow: hidden;
        margin-top: 29px;
        .express_list2 {
          width: 100%;
          overflow: hidden;
          cursor: pointer;
          margin-bottom: 12.3px;
          border-bottom: 1px solid #EBEBEB;
          line-height: 62px;
          .express_dian {
            width: 10px;
            height: 10px;
            background: #DBDBDB;
            border-radius: 50%;
            margin-right: 15px;
            float: left;
            margin-top: 27px;
          }

          .express_wen {
            width: 91%;
            float: left;

            .wen1 {
              width: 100%;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;


              .span3 {
                width: 80%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                float: left;
              }
            }

            .wen2 {
              width: 100%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
              margin-bottom: 10px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }

          .zhai {
            width: 90%;
            padding-left: 31px;
            overflow: hidden;
            float: left;

            .wen3 {
              width: 50%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
              float: left;
            }

            .zhai_left,
            .zhai_right {
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
              float: right;
            }

            .zhai_right {
              margin-left: 30px;
            }

            .zhai_left:hover {
              text-decoration: underline;
              color: var(--biao);
            }

            .zhai_right:hover {
              text-decoration: underline;
              color: var(--biao);
            }
          }
        }
      }
      .el-pagination{
        text-align: center;
        margin-top: 30px;
      }
    }
    .evolution_right{
      width: 25%;
      float: left;
      padding-top: 40px;
      .express_right{
        width: 100%;
        margin-bottom: 50px;
        .express_rtitle{
          width: 100%;
          overflow: hidden;
          border-bottom: 3px solid #DBDBDB;
          padding-bottom: 11px;
          position: relative;
          .waike{
            width: 50%;
            float: left;
            font-size: 20px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #000000;
            line-height: 23px;
          }
          .zi{
            width: 50%;
            float: right;
            text-align: right;
            font-size: 14px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #878787;
            line-height: 23px;
            cursor: pointer;
          }
          .waixian{
            position: absolute;
            bottom: 0;
            left: 0;
            width: 81px;
            height: 3px;
            background: var(--biao);
          }
        }
        .express_rxia{
          width: 100%;
          .express_rimg{
            width: 100%;
            height: 199px;
            margin-top: 20px;
            margin-bottom: 27px;
            cursor: pointer;
          }
          .express_rimg:hover{
            transform: scale(1.05);
          }
          .express_rtxt{
            font-size: 18px;
            font-family: Adobe Heiti Std;
            font-weight: bold;
            color: #000000;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow:hidden;
            cursor: pointer;
          }
          .express_rlist{
            width: 100%;
            overflow: hidden;
            margin-top: 30px;
            margin-bottom: 21px;
            cursor: pointer;
            .express_dian{
              width: 10px;
              height: 10px;
              background: #DBDBDB;
              border-radius: 50%;
              margin-right: 15px;
              float: left;
              margin-top: 6px;
            }
            .wenben{
              width: 85%;
              float: left;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow:hidden;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
            }
          }
        }
      }
      .Journalism_one{
      	width: 100%;
      	.Journalism_onetop{
      		width: 100%;
      		overflow: hidden;
          border-bottom: 2px solid #EEEEEE;
      		.Journalism_xian1{
      			width: 4px;
      			height: 21px;
      			background: var(--xt);
      			float: left;
            margin-right: 4px;
            margin-top: 7px;
      		}
      		.Journalism_xian2{
      			width: 2px;
      			height: 21px;
      			background: var(--xt);
      			float: left;
            margin-right: 12px;
            margin-top: 7px;
      		}
      		.Journalism_txt{
      			width: 24%;
            cursor: pointer;
      			font-size: 18px;
      			font-family: Source Han Sans SC;
      			font-weight: 400;
      			color: #000000;
      			line-height: 38px;
      			position: relative;
            text-align: center;
            float: left;
      			.Journalism_xian3{
              width: 2px;
              height: 16px;
              background: #EEEEEE;
      				position: absolute;
      				right: 0;
              top: 14px;
      			}
      		}
      		.Journalism_right{
      			float: right;
      			width: 90px;
      			height: 12px;
      			font-size: 14px;
      			font-family: Source Han Sans SC;
      			font-weight: bold;
      			color: #878787;
      			line-height: 23px;
            cursor: pointer;
            .zi{
              font-size: 14px;
              font-family: Source Han Sans SC;
              font-weight: bold;
              color: #878787;
              line-height: 23px;
              margin-right: 9px;
              margin-top: 8px;
            }
      		}
      	}
        .Journalism_onebottom{
           width: 100%;
           overflow: hidden;
           margin-top: 19px;
          .Journalism_list{
            width: 100%;
            overflow: hidden;
            margin-bottom: 26px;
            .Journalism_listl{
              width: 40%;
              height: 119px;
              float: left;
              cursor: pointer;
            }
            .Journalism_listl:hover{
              transform: scale(1.05);
            }
            .Journalism_listr{
              width: 53%;
              float: left;
              margin-left: 2%;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
			  overflow: hidden;
              a{
                font-size: 18px;
                font-family: Adobe Heiti Std;
                font-weight: bold;
                text-decoration: underline;
                line-height: 28px;
              }
              a:hover{
                color: var(--xt)!important;
              }
             .listr_xia{
               margin-top: 35px;
               span{
                 font-size: 14px;
                 font-family: Adobe Heiti Std;
                 font-weight: normal;
                 color: #757575;
                 line-height: 28px;
               }
             }
            }
          }
          .Journalism_list2{
            width: 100%;
            overflow: hidden;
            margin-bottom: 22px;
            .Journalism_list2id,.Journalism_list2id2{
              width: 5%;
              max-width: 20px;
              height: 20px;
              background: #E34919;
              border-radius: 50%;
              text-align: center;
              line-height: 20px;
              float: left;
              margin-right: 15px;
              color: #FFFFFF;
              margin-left: 2%;
            }
            .Journalism_list2id2{
              background-color: #D2D2D2;
            }
            .kandian{
              line-height: 20px;
              float: left;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: bold;
              color: #000000;
              margin-right: 10px;
            }
            .Journalism_list2txt{
              width: 80%;
              font-size: 16px;
              line-height: 20px;
              font-family: Adobe Heiti Std;
              color: #000000;
              float: left;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow:hidden;
              cursor: pointer;
            }
          }
        }
      }

    }
  }
}
.browse_list{
  width: 100%;
  overflow: hidden;
  margin-top: 30px;
  .author_nav2r{
    width: 100%;
    float: left;
    overflow: hidden;
    .author_list2{
      width: 100%;
      overflow: hidden;
      cursor: pointer;
      margin-bottom: 30px;
      border-bottom: 1px solid #EBEBEB;
      padding-bottom: 23px;
      .author_wen{
        width: 80%;
        float: left;
        .wen11{
          font-size: 16px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #000000;
          margin-bottom: 11px;
          .author_dian{
            width: 10px;
            height: 10px;
            background: #DBDBDB;
            border-radius: 50%;
            margin-right: 21px;
            float: left;
            margin-top: 6px;
          }
        }
        .wen1{
          width: 100%;
          font-size: 16px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #000000;
          margin-bottom: 10px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow:hidden;
        }
        .wen2{
          width: 100%;
          font-size: 14px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #636363;
          margin-bottom: 10px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow:hidden;
        }
      }
      .zhai{
        width: 100%;
        overflow: hidden;
        float: left;
        .wen3{
          width: 84%;
          float: left;
          font-size: 14px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #636363;
          span{
            color: #FF8813;
          }
        }
        .zhai_left,.zhai_right{
          font-size: 14px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #000000;
          float: right;
        }
        .zhai_right{
          margin-left: 20px;
          margin-right: 2px;
        }
        .zhai_left:hover{
          text-decoration: underline;
          color: var(--biao);
        }
        .zhai_right:hover{
          text-decoration: underline;
          color: var(--biao);
        }
      }
    }
  }
}
.el-pagination{
  text-align: center;
  margin-top: 30px;
}
.addtxt{
  font-weight: bold!important;
  font-size: 20px!important;
}
.add2{
  background-color: var(--xt)!important;
}
.addcu{
  font-size: 22px;
  font-family: Source Han Sans SC;
  font-weight: bold;
  color: #000000;
  border-bottom: 3px solid var(--biao);
}
.add1 {
  color: var(--xt) !important;
  text-decoration: underline;
}
.top{
  margin-top: 20px!important;
}

</style>



// WEBPACK FOOTER //
// src/components/nav/search.vue